import React from 'react';
import { Page } from 'components';
import LockboxesRightHeader from './LockboxesRightHeader';
import LockboxesTable from './LockboxesTable';
import LockboxesContextProvider from './LockboxesContext';

const LockboxesPage: React.FC = () => (
    <LockboxesContextProvider>
      <Page
        type="filled"
        title={'Lockboxes'}
        fillScreenHeight
        headerExtra={<LockboxesRightHeader />}
      >
        <LockboxesTable />
      </Page>
    </LockboxesContextProvider>
  );

export default LockboxesPage;
